module.exports = __webpack_public_path__ + "img/background_c2_mobile.c0194e38.jpg";